import { useSelector } from 'react-redux';
import type { RootState } from '~/redux/store';
import type { ReactNode } from 'react';
import { useEffect } from 'react';
import { BuyerDashboard } from './sections/BuyerDashboard';
import { SellerDashboard } from './sections/SellerDashboard';

const dashboardByRole: Record<string, ReactNode> = {
  SELLER: <SellerDashboard />,
  BUYER: <BuyerDashboard />,
};

function identifyUser(user: { id: string; externalId?: string }) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const FS = (window as any).FS;
  if (!FS || !user?.id) {
    return;
  }

  FS('setIdentity', {
    uid: user.id,
    properties: {
      displayName: user.externalId,
      email: user.externalId,
    },
  });
}

export default function Dashboard() {
  const user = useSelector((state: RootState) => state.auth.user);

  useEffect(() => {
    if (user?.id) {
      identifyUser({ id: user.id, externalId: user.externalId });
    }
  }, [user?.id, user?.externalId]);

  if (!user) return null;

  return (
    <div className="w-full bg-neut-bg-alt min-h-[calc(100vh-70px)]">
      <title>Dashboard</title>
      {dashboardByRole[user.role] ?? <h1>Coming soon</h1>}
    </div>
  );
}
